<template>
    <v-container fluid>
        <v-row>
            <v-col cols="6">
            <v-subheader class="font-weight-bold pr-5 json-key-title">
                Alert Id:
            </v-subheader>
            </v-col>
            <v-col cols="6">
            <v-subheader>
                {{ info.alertId }}
            </v-subheader>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="6">
            <v-subheader class="font-weight-bold pr-5 json-key-title">
                Alert Type:
            </v-subheader>
            </v-col>
            <v-col cols="6">
            <v-subheader>
                {{ formatIssueType(info.type) }}
            </v-subheader>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="6">
            <v-subheader class="font-weight-bold pr-5 json-key-title">
                Alert Amount:
            </v-subheader>
            </v-col>
            <v-col cols="6">
            <v-subheader>
                {{ info.amount }} {{ info.currency }}
            </v-subheader>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="6">
            <v-subheader class="font-weight-bold pr-5 json-key-title">
                Process Refund:
            </v-subheader>
            </v-col>
            <v-col cols="6">
            <v-subheader>
                <v-row>
                    <v-col cols="1">
                        <v-checkbox
                        v-model="form.processRefund"
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="11">
                        <v-container fill-height fluid>
                            <v-row align="center" justify="space-around">
                                <div>Tick to refund the alert upon submission</div>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
            </v-subheader>
            </v-col>
        </v-row>

        <div v-if="!form.processRefund" style="margin-top: 1em;">

            <v-row>
                <v-col cols="6">
                    <v-subheader class="font-weight-bold pr-5 json-key-title">
                        Action Taken:
                    </v-subheader>
                </v-col>
                <v-col cols="6">
                    <v-select
                        v-model="form.action"
                        :items="getActions()"
                        item-text="text"
                        item-value="value"
                        label="Select a response"
                        persistent-hint
                        return-object
                        single-line
                        required
                        solo
                        :rules="rules.required"
                        hint="*Required"
                        :menu-props="{ maxHeight: 'none' }"
                    >
                        <template slot="item" slot-scope="data">
                            <div v-if="data.item.tip.desc" style="width: 100%;">
                                <v-tooltip left>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-bind="attrs" v-on="on">
                                            <span color="primary" dark>
                                                {{ data.item.text }}
                                            </span>
                                        </div>
                                    </template>
                                    <span>
                                        {{ data.item.tip.desc }}
                                    </span>
                                </v-tooltip>
                            </div>
                            <div v-else>
                                <span>
                                    {{data.item.text}}
                                </span>
                            </div>
                        </template>
                    </v-select>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="6">
                    <v-subheader class="font-weight-bold pr-5 json-key-title">
                        Transaction Refunded:
                    </v-subheader>
                </v-col>
                <v-col cols="6">
                    <v-select
                        v-model="form.refund"
                        :items="refundedItems"
                        item-text="text"
                        item-value="value"
                        label="Select a response"
                        persistent-hint
                        return-object
                        single-line
                        required
                        solo
                        v-on:input="handleRefundedChange"
                        :rules="rules.required"
                        hint="*Required"
                    >
                    </v-select>
                </v-col>
            </v-row>

            <v-row v-if="refunded">
                <v-col cols="6">
                <v-subheader class="font-weight-bold pr-5 json-key-title">
                    Date of Refund:
                </v-subheader>
                </v-col>
                <v-col cols="6">
                <v-menu
                    ref="menu"
                    v-model="ethocaTxDateMenu"
                    :close-on-content-click="true"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="form.date"
                        label="Select a Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="rules.required"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                    v-model="form.date"
                    no-title
                    scrollable
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="ethocaTxDateMenu = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(date)"
                    >
                        OK
                    </v-btn>
                    </v-date-picker>
                </v-menu>
                </v-col>
            </v-row>

            <v-row v-if="refunded">
                <v-col cols="6">
                    <v-subheader class="font-weight-bold pr-5 json-key-title">
                        Time of Refund:
                    </v-subheader>
                </v-col>
                <v-col cols="6">
                    <v-menu
                        ref="timeMenuRefEthoca"
                        v-model="menu.time"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="form.time"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="form.time"
                                label="Select a Time"
                                prepend-icon="mdi-clock-time-four-outline"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :rules="rules.required"
                            ></v-text-field>
                        </template>
                        <v-time-picker
                        v-if="menu.time"
                        v-model="form.time"
                        full-width
                        @click:minute="$refs.timeMenuRefEthoca.save(form.time)"
                        ></v-time-picker>
                    </v-menu>
                </v-col>
            </v-row>

        </div>

        <v-row>
            <v-col cols="6">
            <v-subheader class="font-weight-bold pr-5 json-key-title">
                Additional Comments:
            </v-subheader>
            </v-col>
            <v-col cols="6">
            <v-textarea
                v-model="form.comments"
                solo
                name="comments"
                label="Enter additional comments"
                :rules="rules.additionalComments"
                :counter="250"
            ></v-textarea>
            </v-col>
        </v-row>

        <v-row style="margin-top: 1em; margin-bottom: 2em">
            <v-container fill-height fluid>
                <v-row align="center" justify="space-around">
                    <v-btn color="success" @click="sendAction('submit')">Submit</v-btn>
                    <v-btn color="warning" @click="sendAction('reset')">Reset</v-btn>
                    <v-btn color="error" @click="sendAction('close')">Close</v-btn>
                </v-row>
            </v-container>
        </v-row>

        <!-- Snackbar -->
        <v-snackbar
            v-model="snackbar.show"
            :color="snackbar.colour"
            timeout="8000"
            bottom
            rounded="pill"
        >
            {{ snackbar.text }}

            <template v-slot:action="{ attrs }">
            <v-btn
                text
                v-bind="attrs"
                @click="snackbar.show = false"
            >
                Close
            </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        state: Boolean,
        info: Object
    },
    data() {
        return {
            actions: {
                fraud: [
                    {text: "Stopped", value: "stopped", tip: {show: true, desc:  "The order was stopped"}},
                    {text: "Partially Stopped", value: "partially_stopped", tip: {show: true, desc:  "Part of the order was stopped"}},
                    {text: "Previouslly Cancelled", value: "previously_cancelled", tip: {show: true, desc:  "The transaction was already cancelled"}},
                    {text: "Missed", value: "missed", tip: {show: true, desc:  "Too late, the order has shipped / service consumed"}},
                    {text: "Not Found", value: "notfound", tip: {show: true, desc:  "The order could not be found"}},
                    {text: "Account Suspended", value: "account_suspended", tip: {show: true, desc:  "The account has been suspended"}},
                    {text: "In Progress", value: "in_progress", tip: {show: true, desc:  "Currently working on this request"}},
                    {text: "Shipper Contacted", value: "shipper_contacted", tip: {show: true, desc:  "Contacted the shipper and attempting intercept of goods"}},
                    {text: "Other", value: "other", tip: {show: false}},
                ],
                dispute: [
                    {text: "Resolved", value: "resolved", tip: {show: true, desc:  "Case resolved with the customer"}},
                    {text: "Previously Refunded", value: "previously_refunded", tip: {show: true, desc:  "Refund already processed"}},
                    {text: "Unresolved Dispute", value: "unresolved_dispute", tip: {show: true, desc:  "Chargeback will be disputed"}},
                    {text: "Not Found", value: "notfound", tip: {show: true, desc:  "The order could not be found"}},
                    {text: "Other", value: "other", tip: {show: false}},
                ]
            },
            refundedItems: [
                {text: "Refunded", value: "refunded"},
                {text: "Not Refunded", value: "not refunded"},
                {text: "Not Settled", value: "not settled"},
            ],
            rules : {
                additionalComments: [v => (v.length <= 250) || 'Description must be 250 characters or less'],
                required: [value => !!value || "*Required"]
            },           
            refunded: false,
            form: {
                action: null,
                refund: null,
                date: null,
                time: null,
                comments: "",
                processRefund: true,
            },
            snackbar: {
                show: false,
                text: null,
            },
            menu: {
                date: false,
                time: false,
            }
        }
    },
    methods: {
    sendAction(action) {
      switch (action) {
            case 'submit':
                if (this.validateForm()) {
                    axios({
                        method: 'post',
                        url: 'send-risk-response',
                        data: { userId: this.$store.state.user.id, alertResponse: this.form, item: this.info },
                        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                    var resData = response.data;
                    // console.log(resData);
                    if (resData.success) {
                        // console.log(resData);
                        // this.showPopup("green", "Successfully sent alert update.");
                        this.$emit('show', {showBool: false, msg: "Successfully sent alert update.", colour: "green"});
                    } else {
                        // this.showPopup("red", "Code:" + err.code + " Status: " + err._);
                        this.showPopup("red", "There was a problem sending the alert update.");
                    }
                    })
                    .catch(e => {
                    console.log(e);
                        console.log(e);
                        this.showPopup("red", "There was a problem sending the alert update.");
                    })
                }
                break;
            case 'reset':
                this.formReset();
                break;
            case 'close':
                this.formReset();
                this.$emit('show', {showBool: false});
                break;
            default:
                break;
      }
    },
    getActions() {
      var actions = {
        "issuer_alert": this.actions.fraud,
        "customerdispute_alert": this.actions.dispute
      };

      return actions[this.info.type];
    },
    formatIssueType(issueType) {
        var fmtTypes = {
            "issuer_alert": "Confirmed Fraud",
            "customerdispute_alert": "Confirmed Dispute"
        };
        return fmtTypes[issueType];
    },
    showPopup(colour, text) {
      this.snackbar.show = true;
      this.snackbar.text = text;
      this.snackbar.colour = colour;
    },
    handleRefundedChange() {
        if (this.form.refund.value == 'refunded') {
          this.refunded = true;
        } else {
          this.refunded = false;
        }
    },
    validateForm() {
        var form = this.form;
        // var menu = this.menu;

        if (form.processRefund) {
            var d = new Date();

            switch (this.info.type) {
                case 'issuer_alert':
                    form.action = {value: "stopped"};
                    break;
                case 'customerdispute_alert':
                    form.action = {value: "resolved"};
                    break;
            }
            
            form.refund = {text: "Refunded", value: "refunded"};
            form.date = this.getPaddedDate(d);
            form.time = this.getPaddedTime(d);
        }

        // Check action null  
        if (form.action == null) {
            this.showPopup("red", "Action field is empty.");
            return false;
        }
        
        // Check refunded null
        if (form.refund == null) {
            this.showPopup("red", "Refund field is empty.");
            return false;
        }

        // Check refunded
        if (this.refunded) {
            // Check date
            if (form.date == null) {
                this.showPopup("red", "Date field is empty.");
                return false;
            }

            // Check time
            if (form.time == null) {
                this.showPopup("red", "Time field is empty.");
                return false;
            }
        }

        // Check comments <250 chars
        if (form.comments.length > 250) {
            this.showPopup("red", "Additional comments field is greater than 250 characters.");
            return false
        }
        return true;
    },
    getPaddedTime(d) {
        return this.pad(d.getHours())+':'
        + this.pad(d.getMinutes())
        // + this.pad(d.getMinutes())+':'
        // + this.pad(d.getSeconds())
    },
    getPaddedDate(d) {
        return d.getFullYear()+'-'
        + this.pad(d.getMonth()+1)+'-'
        + this.pad(d.getDate())
    },
    pad(n){
        return n<10 ? '0'+n : n
    },
    formReset() {
        this.form = {
            action: null,
            refund: null,
            date: null,
            time: null,
            comments: "",
            processRefund: true,
        }; 
        this.refunded = false;
        this.menu = {
            date: false,
            time: false,
        }
    }
  }
}
</script>

<style>
    .json-key-title {
        display: inline-flex;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }

    /* Hint colour */
    .v-messages__message {
      color: red;
    }
</style>